<template>
  <filtro-adicional-base
    :target="'popover-filtro-empresa'"
    @aplicar-busca="aplicar()"
    @limpar="limpar()"
  >
    <template #conteudo-filtro-adicional>
      <b-row>
        <b-col cols="12">
          <b-form-group>
            <usuario-interno-select
              ref="filtroUsuarioInterno"
              v-model="value.usuarios"
              :multiple="true"
              :label="'Usuário responsável'"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-group>
            <usuario-externo-select
              ref="usuarioContato"
              v-model="value.usuariosExternos"
              class="usuario-select"
              :multiple="true"
              :label="'Usuário contato'"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-group>
            <modelo-select
              ref="filtroModelo"
              v-model="value.modelo"
              :multiple="true"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-group>
            <grupo-empresarial-select
              ref="filtroGrupoEmpresarial"
              v-model="value.grupoEmpresarial"
              :multiple="true"
              :label="'Grupo Empresarial'"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <equipe-select
            v-model="value.equipe"
            multiple
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-group label="ID Omie">
            <v-select
              v-model="value.buscaVinculoOmie"
              :options="[{value: 0, label: 'Com ID Omie'}, {value: 1, label: 'Sem ID Omie'}]"
              multiple
              :reduce="omie => omie.value"
            />
          </b-form-group>
        </b-col>
      </b-row>
    <!-- <b-row>
      <b-col cols="12">
        <b-form-group>
          <proposta-multiselect
            ref="filtroProposta"
            v-model="value.numeroProposta"
            :filtro-adicional="filtroPropostaNumero"
          />
        </b-form-group>
      </b-col>
    </b-row> -->
    </template>
  </filtro-adicional-base>
</template>

<style lang="scss">
.multiselect-popover-filtro {
  min-width: 380px;
  max-width: 500px;
}

.multiselect-popover-filtro .arrow {
  visibility: hidden;
}

.multiselect-popover-filtro .popover-body {
  max-height: calc(70vh - 132px);
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar-track {
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar {
      width: 10px;
      background-color: #f5f5f5;
      }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: #bfbfbf;
    }
}
</style>

<script>
import '@core/scss/vue/libs/vue-select.scss'
import vSelect from 'vue-select'
import { mapGetters } from 'vuex'

export default {
  name: 'FiltroAdicionalEmpresa',
  components: {
    vSelect,
    FiltroAdicionalBase: () => import('@/shared/components/filtro-adicional-base/FiltroAdicionalBase.vue'),
    UsuarioInternoSelect: () => import('@/shared/components/usuario-interno-select/UsuarioInternoSelect.vue'),
    ModeloSelect: () => import('@/shared/components/modelo-select/ModeloSelect.vue'),
    UsuarioExternoSelect: () => import('@/shared/components/usuario-externo-select/UsuarioExternoSelect.vue'),
    // PropostaMultiselect: () => import('@/shared/components/proposta-multiselect/PropostaMultiselect.vue'),
    GrupoEmpresarialSelect: () => import('@/shared/components/grupoempresarial-select/GrupoEmpresarialSelect.vue'),
    EquipeSelect: () => import('@/shared/components/equipe-select/EquipeSelect.vue'),
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      popoverShow: false,
      telas: [],
      eventos: [],
      processos: [],
    }
  },
  computed: {
    ...mapGetters('empresa', ['empresa']),
  },
  methods: {
    onClose() {
      this.popoverShow = false
    },
    aplicar() {
      this.$emit('mais-filtros', this.value)
    },
    limpar() {
      this.value = {
        usuarios: null,
        usuariosExternos: null,
        modelo: null,
        grupoEmpresarial: null,
        numeroProposta: null,
        equipe: null,
        buscaVinculoOmie: [],
      }
    },
    filtroPropostaNumero(propostas) {
      let propostasFilt = []
      propostasFilt = propostas.filter(fil => fil.numeroProposta && fil.numeroProposta !== '' && fil.propostaAprovada === true)
      return propostasFilt
    },
  },
}
</script>
